module.exports = __webpack_public_path__ + "static/media/hashtag-nft-12.bb75c668.jpg";